import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function NF525Landing() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container product-landing nf525-landing">
          <div className="section-header">
            <span className="section-badge">
              {translate("nf525Badge", language)}
            </span>
            <h1 className="product-title nf525-ready-title landing-product-title">
              <span>
                <span className="nf525-ready-title-text">NF525 Ready</span>
              </span>
            </h1>
          </div>

          <div className="landing-sections">
            <div className="landing-section">
              <h2>{translate("nf525WhatTitle", language)}</h2>
              <p>{translate("nf525WhatDesc", language)}</p>
            </div>

            <div className="landing-section">
              <h2>{translate("nf525WhyTitle", language)}</h2>
              <ul className="landing-list">
                <li>{translate("nf525Why1", language)}</li>
                <li>{translate("nf525Why2", language)}</li>
                <li>{translate("nf525Why3", language)}</li>
                <li>{translate("nf525Why4", language)}</li>
              </ul>
            </div>

            <div className="landing-section">
              <h2>{translate("nf525HowTitle", language)}</h2>
              <ul className="landing-list">
                <li>{translate("nf525How1", language)}</li>
                <li>{translate("nf525How2", language)}</li>
                <li>{translate("nf525How3", language)}</li>
                <li>{translate("nf525How4", language)}</li>
              </ul>
            </div>
          </div>

          <div className="landing-cta">
            <a
              href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
                "NF525 Ready - " +
                  (language === "fr" ? "Contact" : "Contact")
              )}`}
              className="landing-link"
            >
              {translate("nf525Cta", language)}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default NF525Landing;
